import { LinnworksLocality } from "@redotech/redo-integrations-definitions-common/linnworks/linnworks";
import * as z from "zod";

export const getLinnworksIntegrationStatus = {
  name: "getLinnworksIntegrationStatus" as const,
  input: z.object({ installAttemptNonce: z.string().uuid().optional() }),
  output: z.object({
    isConnected: z.boolean(),
    accountEmail: z.string().optional(),
    accountUserName: z.string().optional(),
    installAttemptStatus: z
      .enum(["completed", "expired", "pending"])
      .optional(),
    locality: z.enum(LinnworksLocality).optional(),
  }),
};
